import { h, Fragment } from 'preact';
import { useState } from 'preact/hooks';
import clsx from 'clsx';

const CartItemCustomSelections = ({
  configuration,
  isCartPage,
  showMoreSelections = true,
}) => {
  const [open, setOpen] = useState(false);

  const renderOpenSelections = () =>
    configuration.map(({ attributeName, value }) => (
      <p key={`${attributeName}-${value}`}>
        {attributeName}: {value}
      </p>
    ));

  const renderClosedSelections = () => (
    <p>{configuration.map(({ value }) => value).join(', ')}</p>
  );

  return (
    <>
      <p
        className={clsx(
          'text-secondary-1 mb-3',
          isCartPage ? 'font-r-12' : 'font-r-10',
        )}
      >
        {open ? renderOpenSelections() : renderClosedSelections()}
      </p>
      {showMoreSelections && (
        <button
          className="underline appearance-none font-r-12 mb-[19px] lg:mb-0 font-medium"
          onClick={() => setOpen(!open)}
        >
          View {open ? 'less' : 'all'} selections
        </button>
      )}
    </>
  );
};

export default CartItemCustomSelections;
